import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiDeveloperBoard } from "@mdi/js";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { Menu } from "./Menu";

export const DevelopersMenu: React.FC<Menu> = memo(
  ({ handleClick, leftMenuOpen, user }) => {
    const { t } = useTranslation();

    if (!user.is_developer) {
      return null;
    }

    return (
      <HybridRouteListItemButtonLink
        caption="developers"
        name="developers"
        onClick={() => handleClick("developers")}
        title={t("menu.developers.title")}
        url="/developers"
      >
        <ListItemIcon sx={{ minWidth: "2rem" }}>
          <Icon icon={mdiDeveloperBoard} />
        </ListItemIcon>
        {!!leftMenuOpen && (
          <ListItemText
            primary={t("menu.developers.title")}
            slotProps={{
              primary: {
                sx: {
                  fontSize: 14,
                },
              },
            }}
            sx={{ whiteSpace: "normal" }}
          />
        )}
      </HybridRouteListItemButtonLink>
    );
  },
);
